import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const BackButton = ({ className = "" }) => {
  const navigate = useNavigate();
  const goBack = () => {
    const idx = window.history.state?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate("/");
  };
  return (
    <button
      type="button"
      onClick={goBack}
      data-testid="smart-back-button"
      className={`group inline-flex items-center gap-2 rounded-md border border-slate-800 bg-slate-900/60 px-3 py-1.5 text-sm text-slate-300 transition-colors hover:border-slate-600 hover:bg-slate-800 hover:text-white ${className}`}
    >
      <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
      <span className="hidden sm:inline">Back</span>
    </button>
  );
};
